import { render, staticRenderFns } from "./SettingWorkspace.vue?vue&type=template&id=6fa50e10"
import script from "./SettingWorkspace.vue?vue&type=script&lang=js"
export * from "./SettingWorkspace.vue?vue&type=script&lang=js"
import style0 from "./SettingWorkspace.vue?vue&type=style&index=0&id=6fa50e10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports